import React, { Component } from 'react'
import Radium from 'radium'
//import ReactSVG from 'react-svg'

//import images from './../../../config/images'

import '../../../stylesheets/about.css'

class Footer extends Component {
	render() {
		return (
			<footer className="footer">
        <div className="copyright">
          © {new Date().getFullYear()} RPFPC<br />ALL RIGHTS RESERVED
          <span className="legal">The Retired Professional Football Players of Chicago is a 501(C)(3) Non Profit Organization - Tax ID 26-0072511</span>
        </div>
        <div className="address">
          2906 Central St. - #259<br />Evanston, IL  60201-1283<br />
          <h4>E-MAIL</h4><a href="mailto:ProgramDirector@rpfpc.com">ProgramDirector@rpfpc.com</a>
        </div>
        <div className="crafted">
          Carefully Crafted By<br />
          <a href="http://www.38thstreetstudios.com">38th Street Studios LLC</a>
        </div>
      </footer>
		)
	}
}

Footer.propTypes = {}

Footer.defaultProps = {}

export default Radium(Footer)
